import * as THREE from 'three';

export class SnowEffect {
    constructor(width, length, height) {
        this.width = width;
        this.length = length;
        this.height = height;

        this.particleCount = 400; // Significantly reduced from 1500
        this.particles = null;
        this.velocities = [];

        this.init();
    }

    init() {
        const geometry = new THREE.BufferGeometry();
        const positions = [];
        const sizes = [];

        // Texture
        const canvas = document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;
        const ctx = canvas.getContext('2d');
        const grad = ctx.createRadialGradient(16, 16, 0, 16, 16, 16);
        grad.addColorStop(0, 'rgba(255, 255, 255, 1)');
        grad.addColorStop(1, 'rgba(255, 255, 255, 0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, 32, 32);
        const texture = new THREE.CanvasTexture(canvas);

        const material = new THREE.PointsMaterial({
            color: 0xffffff,
            size: 0.15,
            map: texture,
            transparent: true,
            opacity: 0.8,
            blending: THREE.AdditiveBlending,
            depthWrite: false
        });

        // Margins to prevent bleeding into other sections
        const margin = 5.0;
        const validLength = Math.max(1, this.length - (margin * 2));

        const halfHeight = this.height / 2;

        for (let i = 0; i < this.particleCount; i++) {
            // Random position within the section volume
            // X: -width/2 to width/2
            // Y: -halfHeight to halfHeight (Floor to Ceiling)
            // Z: Constrained to center to allow margins

            const x = (Math.random() - 0.5) * this.width;
            const y = (Math.random() - 0.5) * this.height; // -7 to 7
            const z = -(margin + Math.random() * validLength);

            positions.push(x, y, z);

            // Reduced velocity (Slower fall)
            this.velocities.push({
                x: (Math.random() - 0.5) * 0.01,
                y: -(Math.random() * 0.02 + 0.01), // Much slower
                z: (Math.random() - 0.5) * 0.01
            });
        }

        geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));

        this.particles = new THREE.Points(geometry, material);
        // Disable Raycasting to prevent blocking interaction with buttons behind/inside the snow effect
        this.particles.raycast = () => { };
    }

    getMesh() {
        return this.particles;
    }

    update() {
        if (!this.particles) return;

        const positions = this.particles.geometry.attributes.position.array;
        const halfHeight = this.height / 2;

        for (let i = 0; i < this.particleCount; i++) {
            const i3 = i * 3;

            // Update Position
            positions[i3] += this.velocities[i].x;     // X
            positions[i3 + 1] += this.velocities[i].y; // Y
            positions[i3 + 2] += this.velocities[i].z; // Z

            // Reset if out of bounds (floor)
            // Floor is at -halfHeight. Allow small buffer (-1m) to fall through floor.
            if (positions[i3 + 1] < -halfHeight) {
                const margin = 5.0;
                const validLength = Math.max(1, this.length - (margin * 2));

                positions[i3 + 1] = halfHeight; // Reset to ceiling
                positions[i3] = (Math.random() - 0.5) * this.width; // New random X
                positions[i3 + 2] = -(margin + Math.random() * validLength); // New random Z within margins
            }
        }

        this.particles.geometry.attributes.position.needsUpdate = true;
    }
}
